module.exports = __webpack_public_path__ + "media/images/jalousien-96d1b1cd26e21b90172ca89e4de99d9f.jpg";